import { Injectable } from '@angular/core';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class ExtendedNgbDatepickerConfig extends NgbDatepickerConfig {
  minDate = { year: 1980, month: 1, day: 1 };
  maxDate = {
    year:
      new Date().getFullYear() +
      20 +
      (localStorage.getItem('lang') === 'th' ? 543 : 0),
    month: 1,
    day: 1,
  };
}
